import { App } from "@/App";
import { APP_ROUTES } from "@/config/appConfig";
import { useAuthSession } from "@/contexts/AuthSessionContext";
import InspectorPortalLayout from "@/layout/InspectorPortalLayout";
import LoginPage from "@/pages/Auth/LoginPage";
import OtpPage from "@/pages/Auth/OtpPage";
import HelpPage from "@/pages/Help/HelpPage";
import InspectorPortalPage from "@/pages/InspectorPortal/InspectorPortalPage";
import HardNotFoundPage from "@/pages/NotFound/HardNotFoundPage";
import VacationPage from "@/pages/Vacation/VacationPage";
import {
  Navigate,
  createBrowserRouter,
  createMemoryRouter,
  type RouteObject,
} from "react-router-dom";

function IndexRedirect() {
  const { isSessionLoading, session } = useAuthSession();

  if (isSessionLoading) {
    return null;
  }

  const route = session ? APP_ROUTES.PORTAL.VIEWINGS : APP_ROUTES.AUTH.LOGIN;

  return <Navigate to={route} replace />;
}

function withoutLeadingSlash(path: string) {
  return path.replace(/^\//, "");
}

function withoutPortalPrefix(path: string) {
  return path.replace(/^\/portal\/?/, "");
}

const inspectorPortalRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.ROOT,
    element: <App />,
    children: [
      {
        index: true,
        element: <IndexRedirect />,
      },
      {
        path: withoutLeadingSlash(APP_ROUTES.AUTH.LOGIN),
        element: <LoginPage />,
      },
      {
        path: withoutLeadingSlash(APP_ROUTES.AUTH.OTP),
        element: <OtpPage />,
      },
      {
        path: "portal",
        element: <InspectorPortalLayout />,
        children: [
          {
            index: true,
            element: (
              <Navigate
                to={withoutPortalPrefix(APP_ROUTES.PORTAL.VIEWINGS)}
                replace
              />
            ),
          },
          {
            path: withoutPortalPrefix(APP_ROUTES.PORTAL.VIEWINGS),
            element: <InspectorPortalPage />,
          },
          {
            path: withoutPortalPrefix(APP_ROUTES.PORTAL.VACATION),
            element: <VacationPage />,
          },
          {
            path: withoutPortalPrefix(APP_ROUTES.PORTAL.HELP),
            element: <HelpPage />,
          },
        ],
      },
      {
        path: "*",
        element: <HardNotFoundPage />,
      },
    ],
  },
];

export function createInspectorPortalRouter(initialEntries?: string[]) {
  if (initialEntries) {
    return createMemoryRouter(inspectorPortalRoutes, {
      initialEntries,
    });
  }

  return createBrowserRouter(inspectorPortalRoutes);
}
